import React from 'react'

import { PartnerLogo } from 'components'
import useBoundState from 'store'
import BaseBridge from 'config/bridge/BaseBridge'
import { useHistory } from 'react-router-dom'
import { TypesRoutes } from 'routes/mixedRoutes/types'

import { Flex } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'
import { formatToBRL } from '@interco/lib-util'
import { Button } from '@interco/inter-ui/components/Button'

import * as S from './SummaryCheckout.styles'
import { AnalyticsLandingPage } from '../Home.tags'

interface SummaryCheckoutProps {
  payout: number
  handleCheckout: () => void
}

export const SummaryCheckout = ({ payout, handleCheckout }: SummaryCheckoutProps) => {
  const history = useHistory()

  const contentCapitalization = useBoundState((state) => state.contentCapitalization)
  const isLoading = useBoundState((state) => state.isLoading)
  const formOfPayment = useBoundState((state) => state.formOfPayment)

  const openGeneralConditions = () => {
    AnalyticsLandingPage({ action_id: 'condições gerais', ref_type: 'botão' })
    BaseBridge.openPdf(
      'https://static.bancointer.com.br/seguros/capitalization/CondicoesGeraisSortezinha.pdf',
      'Condições Gerais',
    )
  }

  const openRegistrationForm = () => {
    AnalyticsLandingPage({ action_id: 'ficha de cadastro', ref_type: 'botão' })
    history.push(TypesRoutes.REGISTRATION_FORM)
  }

  const openLegalInfo = () => {
    AnalyticsLandingPage({ action_id: 'informações legais', ref_type: 'botão' })
    BaseBridge.openPdf(
      'https://static.bancointer.com.br/seguros/capitalization/InformacoesLegaisSortezinha.pdf',
      'Informações Legais',
    )
  }

  return (
    <S.Footer>
      <PartnerLogo />

      <S.Checkout>
        <Flex direction="column" justifyContent="center">
          <Text variant="caption-1" colorWeight={500}>
            Total a pagar
          </Text>

          <Text variant="headline-h3" as="h3" semiBold color="primary">
            {formatToBRL(payout)}
          </Text>
        </Flex>

        <Button
          data-testid="pay-button"
          fullWidth
          disabled={!formOfPayment.type}
          isLoading={isLoading}
          onClick={handleCheckout}
        >
          Pagar
        </Button>
      </S.Checkout>

      <S.AcceptTerns>
        <Text variant="caption-1" colorWeight={500}>
          Ao continuar declaro estar de acordo com{' '}
          <S.Link onClick={openGeneralConditions}>Condições Gerais</S.Link>,{' '}
          <S.Link onClick={openLegalInfo}>Informações legais</S.Link> e{' '}
          <S.Link onClick={openRegistrationForm}>Ficha de Cadastro</S.Link> da{' '}
          {contentCapitalization.value1}.
        </Text>
      </S.AcceptTerns>
    </S.Footer>
  )
}
